var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShareApple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6344_2741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.64571 17.604C1.78185 18.81 2.32253 19.9342 3.17959 20.7935C4.03666 21.6527 5.15954 22.1962 6.36514 22.3354C10.1554 22.7571 13.8446 22.7571 17.6349 22.3354C18.8405 22.1962 19.9633 21.6527 20.8204 20.7935C21.6775 19.9342 22.2181 18.81 22.3543 17.604C22.5497 15.78 22.7143 13.908 22.7143 12C22.7143 10.092 22.5497 8.22 22.3543 6.39771C22.2181 5.19176 21.6775 4.0675 20.8204 3.20826C19.9633 2.34902 18.8405 1.80548 17.6349 1.66628C13.8902 1.24373 10.1098 1.24373 6.36514 1.66628C5.15954 1.80548 4.03666 2.34902 3.17959 3.20826C2.32253 4.0675 1.78185 5.19176 1.64571 6.39771C1.45028 8.22 1.28571 10.092 1.28571 12C1.28571 13.908 1.45028 15.78 1.64571 17.604Z",
    stroke: "#00C969",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7.71428V16.2857",
    stroke: "#00C969",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2857 12H7.71429",
    stroke: "#00C969",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6344_2741"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareApple);
export default __webpack_public_path__ + "static/media/share-apple.6ee8c519d06957499486f9448a913982.svg";
export { ForwardRef as ReactComponent };